import { ChangeDetectorRef, Component, ElementRef } from '@angular/core';
import { ALK_EVENT_TYPE, AlkEvent, BaseView, ChronocodeCmd, FastSelectData, FindConnectCommand, FindCssRenderCommand, FindFormatCommand, 
  FindMeasureCommand, FindStyleCommand, FreedataCall, FreedataValueVO, GridsterWidget, PhysicalTemplateCmd, 
  PhysicalTemplateEngine, PhysicalTemplateVO, ViewData, 
  WIDGET_GLOBAL_KIND, 
  WorkcomCall} from '@wizeoo/akm-common-lib';
import { WizActionObj, WizCommand, WizEventManager, WizGroupCommand, WizRoot } from '@wizeoo/akm-component-lib';

import { DisplayGrid } from 'angular-gridster2';
import { RouteEngine } from 'src/app/manager/routing/route.engine';
import { APP_EVENT_TYPE } from 'src/app/model/enums';
import { Model } from 'src/app/model/model';

@Component({
  selector: 'thumb-view',
  templateUrl: './thumb.view.html',
})
// Vue d'initialisation pour chargement du contexte
export class ThumbView extends BaseView {

  constructor(public elementRef: ElementRef, public cdref: ChangeDetectorRef ) {
    super(elementRef);
    this.code = 'THUMB';
  }

  public templateCode: string = 'THUMB';

  public currentFDV: FreedataValueVO = null;


  wizBeforeInit(): boolean | Promise<any>[] | WizGroupCommand | WizCommand<any> {
    // console.log('ngOnInit init view');
    
    const calls = [];
    // disponibilité des freedatas pour labels
   if (!Model.getInstance().chronocodeEngine.getChronocodesMap()) {
      // disponibilité des chronocodes pour labels
      calls.push(new ChronocodeCmd(Model.getInstance()).find());
    }
    // disponibilité des freedatas pour labels
    if (!Model.getInstance().freedataEngine.getFreedataMap()) {
      calls.push(new FreedataCall(Model.getInstance()));
    }
    if (!Model.getInstance().measureEngine.getMeasureList()) {
      // vérification des measures
      calls.push(new FindMeasureCommand(Model.getInstance()));
    }

    const physOK: boolean = Model.getInstance().physicalTemplateMap?.get(Model.getInstance().businessUnitCode)?.has(Model.getInstance().visionCode);

    if (!physOK) {
      calls.push(new PhysicalTemplateCmd(Model.getInstance()).find());
    }

    if (!Model.getInstance().styleList) {
      calls.push(new FindStyleCommand(Model.getInstance()));
    }
    if (!Model.getInstance().connectMapExt) {
      // chargement de la liste des fonctions de connexion
      calls.push(new FindConnectCommand(Model.getInstance()));
    }
    // chargement de la liste des formats
    if (!Model.getInstance().formatEngine.getFormatList()) {
      // double appel pour format de base à la bu (*)
      calls.push(new FindFormatCommand(Model.getInstance()).find(ViewData.wildcardDomain, ViewData.wildcardDomain));
      calls.push(new FindFormatCommand(Model.getInstance()).find(Model.getInstance().domainCode, Model.getInstance().businessUnitCode));
    }
    
    // chargement de la liste des rendus css
    if (!Model.getInstance().styleEngine.getCssRenderList()) {
      calls.push(new FindCssRenderCommand(Model.getInstance()).find(Model.getInstance().domainCode, Model.getInstance().businessUnitCode));
    }

    // chargement des messages
    if (!Model.getInstance().workflowEngine.getWorkcomMap()) {
      calls.push(new WorkcomCall(Model.getInstance()));
    }


    if (calls.length > 0) {
      return new WizGroupCommand().configure(calls);
    } else {
      return true;
    }

  }

  public options: any = PhysicalTemplateEngine.gridsterSafe();

  
  public template: PhysicalTemplateVO = null;
  public tabWidgets: GridsterWidget[]; // la liste des widgets de cette vue

  // public templateCode2: string = 'DETSRC';
  // public template2: PhysicalTemplateVO = null;
  // public tabWidgets2: GridsterWidget[]; // la liste des widgets de cette vue


  wizAddListener() {
    super.wizAddListener();
    WizEventManager.addListener(this, WizRoot.root(), ALK_EVENT_TYPE.PIVOT_DOUBLE, this.fastSelect); 
    WizEventManager.addListener(this, WizRoot.root(), ALK_EVENT_TYPE.UNSELECT, this.fastSelect); 
    WizEventManager.addListener(this, WizRoot.root(), ALK_EVENT_TYPE.WIDGET_READY, this.feedProto); 
  }

  wizRemoveListener() {
    super.wizRemoveListener();
    WizEventManager.removeListener(this, WizRoot.root(), ALK_EVENT_TYPE.PIVOT_DOUBLE);
    WizEventManager.removeListener(this, WizRoot.root(), ALK_EVENT_TYPE.UNSELECT);
    WizEventManager.removeListener(this, WizRoot.root(), ALK_EVENT_TYPE.WIDGET_READY);
  }


  private feedProto(e: AlkEvent): void {
    //setTimeout(() => {
    setTimeout(() => {
      if(!!Model.getInstance().currentPrototype) {
        let fsd: FastSelectData = {fei: null, kind: WIDGET_GLOBAL_KIND.FREEDATA, data: Model.getInstance().currentPrototype};
        WizEventManager.dispatchEvent(WizRoot.root(), new AlkEvent(ALK_EVENT_TYPE.PROGRAMMATIC_FEED, fsd));
      }
    }, 0);
  }



  public fastSelect(e: AlkEvent): void {
    // console.log('fastSelect', e.type, e.data?.data);
    let fdv: FreedataValueVO = e.data?.data || null;
    Model.getInstance().currentPrototype = fdv;
    if(!!Model.getInstance().currentPrototype) {
      Model.getInstance().navigationEngine.navigate(RouteEngine.ADD_VIEW);
    }
  }

  // pas de produit pour moi, je jump sur la vue add
  public hasAlmostOne: boolean = false;

  /**
   * Synchronisation des données
   */
  public wizSynchronizeData(): void {
    
    Model.getInstance().currentViewCode = this.code;

    // alimentation du bread
    WizEventManager.dispatchEvent(WizRoot.root(), new AlkEvent(APP_EVENT_TYPE.BREAD, '$.widget.show.thumb.$'));



    // prise du bon template
    this.template = Model.getInstance().physicalTemplateEngine.getTemplate(this.templateCode);

    // conf de base gridster
    this.options = Model.getInstance().physicalTemplateEngine.gridsterOption();
    this.options.gridType = this.template?.screenMode || ViewData.DEFAULT_SCREEN_MODE;
    this.options.outerMargin = false;
    this.options.draggable.enabled = false;
    this.options.resizable.enabled = false;
    this.options.mobileBreakpoint= 100;
    this.options.displayGrid = DisplayGrid.None;

    this.feedTab();
    this.applyGridsterConfig();
    this.feed();

  }


  private feedTab(): void {
    let wao: WizActionObj = new WizActionObj(this.templateCode, null, null);
    wao.featureCode = Model.getInstance().visionCode + ViewData.KEY_SEPARATOR + this.code;
    ViewData.currentTab = wao;
  }

  private applyGridsterConfig(): void { 
    // console.log('applygrid', this.options, this.meGridster);
    if(!!this.options?.api) {    
      //this.options.gridType = this.template?.screenMode || PhysicalTemplateManager.DEFAULT_SCREEN_MODE;
      this.options.minCols = 10;
      this.options.minRows = 10;
      this.options.api.optionsChanged();
      // console.log('applygrid really', this.options);
    }
  }

  private feed(): void {
    
    let map: Map<string, GridsterWidget> = new Map();
    if(this.template) {
             
      // 1
      this.template.widgets.forEach(gw => {
        map.set(gw.uid, gw);

      });

      this.tabWidgets = this.template.widgets;


    } else {
      this.tabWidgets = [];
    }

    // alimentation de la map de widget de l'engine
    Model.getInstance().widgetEngine.widgetConfigMap = map;
  

    setTimeout(() => {
      this.cdref.markForCheck();
    }, 0);
  }


  /** injection correcte du GiVO dans les widgets... Cette merde de Gridster flingue les getter / setters */
  public getRealVOFromGridsterLimitation(item: GridsterWidget): GridsterWidget {
    let res: GridsterWidget = null;
    this.tabWidgets.forEach((givo: GridsterWidget) => {
      if (givo.uid === item.uid) {
        res = givo;
      }
    });
    return res;
  }


}